import { MENU_CODE, returnImgByMenuCode } from "constants/layout";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, withRouter } from "react-router-dom";

const menu = [
  {
    id: 34,
    menuName: "Thông báo từ TCT",
    menuCode: MENU_CODE.NOTICE_FROM_TCT.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: "/notice-from-TCT",
    children: [],
  },
  {
    id: 34,
    menuName: "Đăng ký/ Ủy quyền/ Đề nghị",
    menuCode: MENU_CODE.DATA_FORMAT.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      {
        id: 35,
        menuName: "Đăng ký sử dụng",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/data-format/registry-invoice",
        children: [],
      },
      {
        id: 35,
        menuName: "Ủy quyền lập hóa đơn",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/data-format/registry-delegate",
        children: [],
      },
      {
        id: 35,
        menuName: "Đề nghị cấp HDDT có mã",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/data-format/request-invoice-code",
        children: [],
      },
    ],
  },
  {
    id: 34,
    menuName: "Phát hành hóa đơn GTGT",
    menuCode: MENU_CODE.ISSUE_VAT_INVOICE.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      {
        id: 35,
        menuName: "HĐ GTGT có mã",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/issue-vat-invoice/have-code",
        children: [],
      },
      {
        id: 35,
        menuName: "HĐ GTGT không mã",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/issue-vat-invoice/none-code",
        children: [],
      },
    ],
  },
  {
    id: 34,
    menuName: "Phát hành hóa đơn BH",
    menuCode: MENU_CODE.ISSUE_SALES_INVOICE.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      {
        id: 35,
        menuName: "HĐ BH có mã",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/issue-sales-invoice/have-code",
        children: [],
      },
      {
        id: 35,
        menuName: "HĐ BH không mã",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/issue-sales-invoice/none-code",
        children: [],
      },
    ],
  },
  {
    id: 40,
    menuName: "Phát hành hóa đơn khác",
    menuCode: MENU_CODE.ISSUE_SALES_INVOICE.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      {
        id: 41,
        menuName: "Tem,vé (HĐ GTGT) có mã",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/issue-invoice-tickets/have-code",
        children: [],
      },
      {
        id: 42,
        menuName: "Tem,vé (HĐ GTGT) không mã",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/issue-invoice-tickets/none-code",
        children: [],
      },
    ],
  },
  {
    id: 34,
    menuName: "Thông tin chung",
    menuCode: MENU_CODE.GENERAL_INFORMATIONS.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      {
        id: 35,
        menuName: "Danh sách đơn vị kinh doanh",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/business-unit-manager/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách tiền tệ",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/currency-manager/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách VAT",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/vat-manager/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách phương thức thanh toán",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/payment-method-manager/list",
        children: [],
      },
    ],
  },
];

const ConfigMenu = props => {
  const { t, i18n } = useTranslation();
  // const { menuArr } = props;
  return (
    <React.Fragment>
      {menu.map((childItem, index) => (
        <React.Fragment key={index}>
          <li>
            <Link
              to={childItem.historyToken ? childItem.historyToken : "/#"}
              //   className={
              //     childItem.children && childItem.children.length > 0
              //       ? "has-arrow"
              //       : ""
              //   }
            >
              <i className={returnImgByMenuCode(childItem.menuCode)}></i>
              <span className="badge rounded-pill bg-info float-end"></span>
              <span>{childItem.menuName}</span>
            </Link>
            {childItem.children.length > 0 && (
              <ul className="sub-menu" aria-expanded="false">
                {childItem.children.map((child, index1) => {
                  let dataHref = "";
                  if (child.moreToken) {
                    dataHref = child.moreToken.join("___");
                  }
                  return (
                    <li key={index1}>
                      <Link
                        className={
                          child.children && child.children.length > 0
                            ? "has-arrow"
                            : ""
                        }
                        to={child.historyToken
                          .toLowerCase()
                          .split("_")
                          .join("-")}
                        datahref={dataHref}
                      >
                        {/* <i
                      className={returnImg(
                        child.historyToken.toLowerCase().split("_").join("-")
                      )}
                    ></i> */}
                        <span>{child.menuName}</span>
                      </Link>
                      {/* {child.children &&
                child.children.map((sub, keyIndex) => (
                  <ul key={keyIndex} className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/ecommerce-products">{sub.menuName}</Link>
                    </li>
                  </ul>
                ))} */}
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
          {/* <li key={index} className="menu-title">
            {childItem.menuName}
          </li> */}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

ConfigMenu.propTypes = {
  lang: PropTypes.object,
  menuArr: PropTypes.any,
};

export default withRouter(ConfigMenu);